export const muiComponentsMenusPopover = {
  MuiPopover: {
    styleOverrides: {
      paper: {
        backgroundImage: 'none',
        backgroundColor: 'var(--app-bg-panel)',
        color: 'var(--app-text-primary)',
        border: '1px solid var(--app-border-light)',
        boxShadow: 'var(--app-elevated-shadow)',
        fontFamily: 'var(--app-font-sans)',
        fontSize: 'var(--app-font-size-popup)',
        fontWeight: 'var(--app-font-weight-regular)',
        minWidth: 'var(--app-popup-min-width)',
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        backgroundImage: 'none',
        backgroundColor: 'var(--app-bg-panel)',
        color: 'var(--app-text-primary)',
        border: '1px solid var(--app-border-light)',
        borderRadius: 'var(--app-radius-md)',
        boxShadow: 'var(--app-elevated-shadow)',
        fontFamily: 'var(--app-font-sans)',
        fontSize: 'var(--app-font-size-popup)',
        fontWeight: 'var(--app-font-weight-regular)',
        minWidth: 'var(--app-popup-min-width)',
      },
    },
  },
}
